
import { EstacaoType } from "../screens/Station";
import { PiChargingStationFill } from "react-icons/pi";
import { ProgressBar } from "primereact/progressbar";
import { BsFillPlugFill } from "react-icons/bs";
import { GrStatusInfo } from "react-icons/gr";
import { HiOutlineStatusOnline, HiOutlineStatusOffline } from "react-icons/hi";
import { GiTwoCoins } from "react-icons/gi";
import { FaPix } from "react-icons/fa6";
import { BsLightningFill } from "react-icons/bs";
type Props = {
    estacao: EstacaoType | null,
    loadingStatus: boolean
    dark?: boolean
    selected?: boolean
}

export const CardEstacao = ({ estacao, loadingStatus, dark }: Props) => {
    const isAvailable = estacao?.status === 'LIVRE' || estacao?.status === 'ONLINE';
    const iconColor = dark ? 'white' : (isAvailable ? 'white' : 'lightgray')//'#06B6D4' : 'dimgray';
    const icon = isAvailable ? <HiOutlineStatusOnline size={20} color={dark ? 'white' : '#06B6D4'} style={{ marginLeft: 5 }} /> : <HiOutlineStatusOffline size={16} color="#744" style={{ marginLeft: 5 }} />;
    return (

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <PiChargingStationFill size={48} color={iconColor} style={{ marginRight: 10 }} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 14, fontWeight: 'bold', color: dark ? 'white' : (isAvailable ? 'white' : 'lightgray') }}>
                    ELETROPOSTO - {estacao?.nome.toUpperCase()}
                </div>
                {loadingStatus ?
                    <ProgressBar mode="indeterminate" style={{ height: '6px', width: 180 }} /> :
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: 12, color: dark ? 'white' : (isAvailable ? 'white' : 'lightgray'), marginTop: -2 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            Conectores:  {estacao?.conectores?.map(c => (<><BsFillPlugFill style={{ marginLeft: 5 }} />{c.plugue.nome}</>))}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: -4 }}>
                            Status: {estacao?.status} {icon}
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export const CardEstacaoVertical = ({ estacao, loadingStatus, dark }: Props) => {
    const isAvailable = estacao?.status === 'LIVRE' || estacao?.status === 'ONLINE';
    const iconColor = dark ? 'white' : (isAvailable ? 'white' : 'lightgray')//'#06B6D4' : 'dimgray';
    const icon = isAvailable ? <HiOutlineStatusOnline size={16} color={dark ? 'white' : '#06B6D4'} style={{ marginLeft: 5 }} /> : <HiOutlineStatusOffline size={16} color="#744" style={{ marginLeft: 5 }} />;
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <PiChargingStationFill size={40} color={iconColor} style={{ marginRight: 3, marginBottom: -3 }} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 14, fontWeight: 'bold', color: dark ? 'white' : (isAvailable ? 'white' : 'lightgray') }}>
                    {estacao?.nome.toUpperCase()}
                </div>
                {loadingStatus ?
                    <ProgressBar mode="indeterminate" style={{ height: '2px', width: 50 }} /> :
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -4 }}>
                        <div style={{ fontSize: 10 }}>Wifi </div>
                        {icon}
                    </div>
                }
            </div>
        </div>
    )
}

export type EntradaType = {
    url: string
    id: number
    user: string
    tipo: string
    valor: number
    data: string
    hora: string
    txid: string
    qrcode: string
    status: string
}

export const CardEntrada = (entrada: EntradaType) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', backgroundColor: '#333', borderRadius: 8, padding: 10, marginBottom: 10 }}>
            <FaPix size={60} color='lightgray' style={{ marginRight: 10, marginLeft: 10 }} />
            <div style={{ width: 2, height: 60, backgroundColor: 'lightgray', marginRight: 10 }}></div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 14, fontWeight: 'bold', color: 'lightgray' }}>
                    ENTRADAS <GiTwoCoins size={14} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: 12, color: 'lightgray', marginTop: -2 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        Tipo:  {entrada.tipo==='P'?'PIX':'DINHEIRO'}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Valor:  R$ {entrada.valor.toFixed(2).toString().replace('.', ',')}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Data: {entrada.data.split('-')[2]}/{entrada.data.split('-')[1]}/{entrada.data.split('-')[0]}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Hora: {entrada.hora.split(':')[0]}:{entrada.hora.split(':')[1]}
                    </div>
                </div>
            </div>
        </div>
    )
}

export type TarifaType = {
    url: string
    id: number
    data: string
    valor: number
}

export type RecargaType = {
    url: string
    id: number
    user: string
    energia: number
    tarifa: TarifaType
    data: string
    hora: string
}

export const CardRecarga = (recarga: RecargaType) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', backgroundColor: '#333', borderRadius: 8, padding: 10, marginBottom: 10 }}>
            <BsLightningFill size={60} color='lightgray' style={{ marginRight: 10, marginLeft: 10 }} />
            <div style={{ width: 2, height: 60, backgroundColor: 'lightgray', marginRight: 10 }}></div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 14, fontWeight: 'bold', color: 'lightgray' }}>
                    RECARGA <GiTwoCoins size={14} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: 12, color: 'lightgray', marginTop: -2 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        Energia:  {recarga.energia} kWh
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Valor: R$ {(recarga.tarifa.valor*recarga.energia).toFixed(2).toString().replace('.', ',')}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Data: {recarga.data.split('-')[2]}/{recarga.data.split('-')[1]}/{recarga.data.split('-')[0]}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: -3 }}>
                        Hora: {recarga.hora.split(':')[0]}:{recarga.hora.split(':')[1]}
                    </div>
                </div>
            </div>
        </div>
    )
}